import type { ComboboxItem } from "@mantine/core";

export const logoutTimes: ComboboxItem[] = [
  {
    value: "5",
    label: "5 min",
  },
  {
    value: "15",
    label: "15 min",
  },
  {
    value: "30",
    label: "30 min",
  },
  {
    value: "60",
    label: "60 min",
  },
  {
    value: "90",
    label: "90 min",
  },
];
